<template>
  <main class="ang-main pt-0 pb-0 bg-main min-h-screen relative z-10 overflow-hidden">
    <router-view/>
    <div class="absolute right-0 top-[25vh] z-10">
      <svg
        width="122"
        height="201"
        viewBox="0 0 168 201"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="md:w-[106px] 2xl:w-[116px]"
      >
        <path
          d="M410.102 137.437L80.3539 199.63C43.9309 206.483 8.878 182.554 2.02727 146.118L1.17093 141.72C-5.67979 105.283 18.2406 70.2176 54.6637 63.3643L384.469 1.17088C420.892 -5.68239 455.945 18.2469 462.796 54.6835L463.595 59.081C470.503 95.4604 446.525 130.583 410.102 137.437Z"
          fill="#FFD900"
        />
      </svg>
    </div>
    <div class="absolute right-0 top-[33vh] z-0">
      <svg
        width="163"
        height="262"
        viewBox="0 0 208 262"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="md:w-[140px] 2xl:w-[172px]"
      >
        <path
          d="M0.000488281 0L207.52 155.683L61.5999 261.738L0.000488281 0Z"
          fill="url(#paint0_linear_166_3064)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_166_3064"
            x1="-193.818"
            y1="-220.846"
            x2="117.435"
            y2="90.291"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#591144"/>
            <stop
              offset="1"
              stop-color="#F7B9BF"
            />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div class="absolute left-0 top-[57vh] z-0">
      <svg
        width="147"
        height="204"
        viewBox="0 0 181 204"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="md:w-[125px] 2xl:w-[163px]"
      >
        <path
          d="M116.781 149.432C119.293 124.189 139.331 104.886 163.594 102.373C166.791 50.8594 128.769 5.68493 76.9894 0.487869C24.0104 -4.82342 -23.2025 33.8404 -28.5118 86.7819C-33.8211 139.781 4.82838 187.011 57.7502 192.322C81.0427 194.664 103.193 188.496 121.177 176.388C117.523 168.279 115.81 159.027 116.781 149.432Z"
          fill="#F6E1A0"
        />
        <path
          d="M49.415 115.851C48.4445 117.222 46.5605 117.564 45.1904 116.651C43.8202 115.68 43.4777 113.795 44.3911 112.425C45.3617 111.054 47.2456 110.711 48.6158 111.625C49.9859 112.596 50.3284 114.481 49.415 115.851Z"
          fill="#591245"
        />
        <path
          d="M91.0332 144.292C90.0627 145.663 88.1787 146.006 86.8086 145.092C85.4384 144.121 85.0959 142.236 86.0093 140.866C86.9798 139.495 88.8638 139.152 90.2339 140.066C91.6041 141.037 91.9466 142.922 91.0332 144.292Z"
          fill="#591245"
        />
        <path
          d="M31.2036 153.201C30.2331 154.572 28.3491 154.915 26.979 154.001C25.6088 153.03 25.2663 151.146 26.1797 149.775C27.1502 148.404 29.0342 148.062 30.4043 148.975C31.8316 149.946 32.1741 151.831 31.2036 153.201Z"
          fill="#591245"
        />
        <path
          d="M133.965 76.0451C132.994 77.4157 131.11 77.7584 129.74 76.8446C128.37 75.8738 128.027 73.9891 128.941 72.6185C129.911 71.2479 131.795 70.9052 133.165 71.8189C134.535 72.7898 134.935 74.6745 133.965 76.0451Z"
          fill="#591245"
        />
        <path
          d="M51.5273 61.2535C50.5568 62.6241 48.6729 62.9668 47.3027 62.053C45.9326 61.0822 45.59 59.1975 46.5034 57.8269C47.474 56.4562 49.3579 56.1136 50.7281 57.0273C52.0982 57.9982 52.4407 59.8828 51.5273 61.2535Z"
          fill="#591245"
        />
        <path
          d="M180.093 193.978C180.093 199.29 175.754 203.63 170.444 203.63C165.135 203.63 160.796 199.29 160.796 193.978C160.796 188.667 165.135 184.327 170.444 184.327C175.754 184.327 180.093 188.61 180.093 193.978Z"
          fill="#F6E1A0"
        />
      </svg>
    </div>
    <div class="absolute left-0 top-[117vh] z-0">
      <svg
        width="154"
        height="296"
        viewBox="0 0 215 296"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="md:w-[140px] 2xl:w-[190px]"
      >
        <path
          d="M187.198 76.7055L-54.4134 272.955C-69.4595 285.176 -91.6317 282.884 -103.848 267.843C-116.065 252.803 -113.764 230.631 -98.7179 218.41L142.893 22.1605C157.939 9.93926 180.111 12.2321 192.328 27.2726C204.545 42.313 202.244 64.4843 187.198 76.7055Z"
          stroke="#591245"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M-51.1561 225.043L145.629 65.2036"
          stroke="#591245"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M167.293 47.6074C184.376 68.6391 181.171 99.5206 160.132 116.61C139.092 133.699 108.209 130.506 91.1263 109.474C74.0432 88.4424 77.2482 57.5609 98.2877 40.4715C119.327 23.382 150.21 26.5757 167.293 47.6074Z"
          fill="#EA5160"
        />
      </svg>
    </div>
    <div class="absolute left-1/2 top-[88%] transform md:translate-x-[44%] 2xl:translate-x-[62%] z-0">
      <svg
        width="63"
        height="92"
        viewBox="0 0 94 92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="md:w-[63px] 2xl:w-[89px]"
      >
        <path
          d="M1.91337 56.9514C-3.85941 32.6728 11.0967 8.33364 35.3453 2.51318L38.1531 1.82549C62.4239 -3.94235 86.7608 11.0241 92.5862 35.2805C98.3589 59.5591 83.4028 83.8983 59.1542 89.7187L56.3464 90.4064C32.0756 96.1743 7.73876 81.2078 1.91337 56.9514Z"
          fill="#591245"/>
      </svg>
    </div>
    <div class="absolute left-1/2 top-[86%] transform translate-x-[-50%] z-0">
      <svg
        width="161"
        height="218"
        viewBox="0 0 217 218"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="md:w-[161px] 2xl:w-[210px]"
      >
        <path
          d="M150.016 207.768C204.551 184.782 230.119 121.922 207.124 67.3676C184.129 12.8127 121.279 -12.7786 66.7442 10.2077C12.2095 33.194 -13.3585 96.0536 9.63638 150.608C32.6312 205.163 95.4813 230.755 150.016 207.768Z"
          stroke="#591245"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <div class="absolute right-0 top-[125vh] z-0">
      <svg
        width="260"
        height="385"
        viewBox="0 0 380 385"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="md:w-[190px] 2xl:w-[250px]"
      >
        <path
          d="M362.448 13.2928C356.291 16.5901 345.178 24.3129 335.06 33.7682C301.444 65.2821 217.555 19.3044 184.283 95.0777C163.155 143.239 122.535 156.72 98.4649 164.337C13.3632 191.302 -4.79668 256.877 2.21152 294.003C12.0532 346.441 67.1492 372.292 114.979 359.37C184.058 340.721 200.912 377.785 249.078 383.946C283.647 388.336 320.28 356.806 331.019 347.763C362.701 321.119 377.404 279.898 397.406 243.596C414.564 212.507 473.94 165.427 489.856 136.914C514.565 92.648 498.696 36.7147 454.413 11.996C424.67 -4.67207 389.724 -2.99587 362.448 13.2928Z"
          fill="url(#paint0_linear_166_3049)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_166_3049"
            x1="184"
            y1="252"
            x2="821.889"
            y2="-50.235"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#DAE3E4"/>
            <stop
              offset="1"
              stop-color="#2D9EB1"
            />
          </linearGradient>
        </defs>
      </svg>

    </div>
  </main>
</template>

<script>

export default {
  data () {
    return {}
  },
  name: 'WideApp',
  methods: {
    reset () {
      window.location.href = '/'
    }
  }
}
</script>
